import { Button } from "@/components/ui/button";

const AccesBilanComplet = () => {
  const handleActiverAcces = () => {
    // Placeholder - comportement à définir ultérieurement
  };

  return (
    <div className="min-h-screen bg-background">
      <main className="container max-w-2xl mx-auto px-4 py-24">
        <div className="text-center">
          <h1 className="text-3xl font-semibold text-foreground mb-12">
            Accéder au bilan prévention complet
          </h1>

          <div className="mb-16">
            <p className="text-muted-foreground text-base leading-relaxed">
              Cette évaluation approfondie permet d'avoir une vision globale de votre prévention.
            </p>
            <p className="text-muted-foreground text-base leading-relaxed mt-4">
              Elle affine les dimensions déjà explorées et intègre d'autres déterminants clés du mode de vie,
              <br />
              pour vous offrir une lecture claire et personnalisée de ce qui compte vraiment à long terme.
            </p>
          </div>

          <p className="text-muted-foreground text-sm mb-12">
            Accès au bilan prévention complet — 9,99 €
          </p>

          <Button
            className="bg-primary hover:bg-primary/90 text-primary-foreground px-10 py-3"
            onClick={handleActiverAcces}
          >
            Activer l'accès
          </Button>

          <p className="text-muted-foreground text-xs mt-6">
            Accès immédiat. Sans engagement.
          </p>
        </div>
      </main>
    </div>
  );
};

export default AccesBilanComplet;
